


































































import { SharedState } from "@/common/state";
import { onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import AtRestSourceCard from "./source-cards/AtRestSourceCard.vue";
import Processing from "@/components/table/Processing.vue";
import { UseModal } from "@/components/root/modal";
import { SourceBrief } from "./data/model";
import SourceDetailsModalVue from "./modals/source-details/SourceDetailsModal.vue";
import ThemeImg from "@/components/ThemeImg.vue";
import InMotionSourceCard from "./source-cards/InMotionSourceCard.vue";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
export default Vue.extend({
  components: {
    // Search,
    ThemeImg,
    AtRestSourceCard,
    Processing,
    InMotionSourceCard,
    PageWithMainContainer,
    SimpleNavTabs,
  },
  setup(_, { root: { $router } }) {
    const {
      sources_tabs,
      set_selected_source_tab,
      selected_source_tab,
      search_query,
      is_searching,
      is_loading_sources,
      display_sources,
      clear_items,
      setup_data_source,
      setup_session_based_data_source,
    } = state;

    const show_source_config_modal = async (source: SourceBrief) => {
      await UseModal().show(SourceDetailsModalVue, source);
    };

    onMounted(() => {
      SharedState.onReady(async () => {
        if (SharedState.is_biz_user.value) {
          $router.replace("/");
          return;
        }

        await state.init();
        const { tab, action, source } = $router.currentRoute.query || {};
        console.log(tab, source, action);
        if (tab && action && source) {
          state.set_selected_source_tab(
            state.sources_tabs.value.find((f) => f.id === tab)!
          );

          switch (action) {
            case "setup":
              setup_data_source(
                display_sources.value.find((d) => d.id === source)!
              );
              break;
            case "create_session":
              const source_brief = state.all_sources.value.find(
                (f) => f.id == source
              )!;
              const payload = { ...source_brief, action: "start_scan_session" };
              await UseModal().show(SourceDetailsModalVue, payload);
              break;
          }
        }
      });
    });

    return {
      sources_tabs,
      set_selected_source_tab,
      selected_source_tab,
      search_query,
      is_searching,
      is_loading_sources,
      display_sources,
      clear_items,
      setup_data_source,
      setup_session_based_data_source,
      show_source_config_modal,
    };
  },
});
